const countries = [
  { name: "Afghanistan", value: "Afghanistan", code: "+93" },
  { name: "Albania", value: "Albania", code: "+355" },
  { name: "Algeria", value: "Algeria", code: "+213" },
  { name: "American Samoa", value: "American Samoa", code: "+1684" },
  { name: "Andorra", value: "Andorra", code: "+376" },
  { name: "Angola", value: "Angola", code: "+244" },
  { name: "Anguilla", value: "Anguilla", code: "+1264" },
  { name: "Antarctica", value: "Antarctica", code: "+672" },
  { name: "Antigua and Barbuda", value: "Antigua and Barbuda", code: "+1268" },
  { name: "Argentina", value: "Argentina", code: "+54" },
  { name: "Armenia", value: "Armenia", code: "+374" },
  { name: "Aruba", value: "Aruba", code: "+297" },
  { name: "Australia", value: "Australia", code: "+61" },
  { name: "Austria", value: "Austria", code: "+43" },
  { name: "Azerbaijan", value: "Azerbaijan", code: "+994" },
  { name: "Bahamas", value: "Bahamas", code: "+1242" },
  { name: "Bahrain", value: "Bahrain", code: "+973" },
  { name: "Bangladesh", value: "Bangladesh", code: "+880" },
  { name: "Barbados", value: "Barbados", code: "+1246" },
  { name: "Belarus", value: "Belarus", code: "+375" },
  { name: "Belgium", value: "Belgium", code: "+32" },
  { name: "Belize", value: "Belize", code: "+501" },
  { name: "Benin", value: "Benin", code: "+229" },
  { name: "Bermuda", value: "Bermuda", code: "+1441" },
  { name: "Bhutan", value: "Bhutan", code: "+975" },
  { name: "Bolivia", value: "Bolivia", code: "+591" },
  {
    name: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
    code: "+387",
  },
  { name: "Botswana", value: "Botswana", code: "+267" },
  { name: "Bouvet Island", value: "Bouvet Island", code: "+47" },
  { name: "Brazil", value: "Brazil", code: "+55" },
  {
    name: "British Antarctic Territory",
    value: "British Antarctic Territory",
    code: "+599",
  },
  {
    name: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
    code: "+246",
  },
  {
    name: "British Virgin Islands",
    value: "British Virgin Islands",
    code: "+1284",
  },
  { name: "Brunei", value: "Brunei", code: "+673" },
  { name: "Bulgaria", value: "Bulgaria", code: "+359" },
  { name: "Burkina Faso", value: "Burkina Faso", code: "+226" },
  { name: "Burundi", value: "Burundi", code: "+257" },
  { name: "Cabo Verde", value: "Cabo Verde", code: "+238" },
  { name: "Cambodia", value: "Cambodia", code: "+855" },
  { name: "Cameroon", value: "Cameroon", code: "+237" },
  { name: "Canada", value: "Canada", code: "+1" },
  { name: "Cape Verde", value: "Cape Verde", code: "+238" },
  { name: "Cayman Islands", value: "Cayman Islands", code: "+1345" },
  {
    name: "Central African Republic",
    value: "Central African Republic",
    code: "+236",
  },
  { name: "Chad", value: "Chad", code: "+235" },
  { name: "Chile", value: "Chile", code: "+56" },
  { name: "China Mainland", value: "China", code: "+86" },
  { name: "Christmas Island", value: "Christmas Island", code: "+672" },
  {
    name: "Cocos [Keeling] Islands",
    value: "Cocos [Keeling] Islands",
    code: "+672",
  },
  { name: "Colombia", value: "Colombia", code: "+57" },
  { name: "Comoros", value: "Comoros", code: "+269" },
  { name: "Congo - Brazzaville", value: "Congo - Brazzaville", code: "+242" },
  { name: "Congo - Kinshasa", value: "Congo - Kinshasa", code: "+243" },
  { name: "Cook Islands", value: "Cook Islands", code: "+682" },
  { name: "Costa Rica", value: "Costa Rica", code: "+506" },
  { name: "Croatia", value: "Croatia", code: "+385" },
  { name: "Cuba", value: "Cuba", code: "+53" },
  { name: "Curacao", value: "Curacao", code: "+599" },
  { name: "Cyprus", value: "Cyprus", code: "+357" },
  { name: "Czech Republic", value: "Czech Republic", code: "+420" },
  { name: "Côte d'Ivoire", value: "Côte d'Ivoire", code: "+225" },
  { name: "Denmark", value: "Denmark", code: "+45" },
  { name: "Djibouti", value: "Djibouti", code: "+253" },
  { name: "Dominica", value: "Dominica", code: "+1767" },
  { name: "Dominican Republic", value: "Dominican Republic", code: "+1809" },
  { name: "Ecuador", value: "Ecuador", code: "+593" },
  { name: "Egypt", value: "Egypt", code: "+20" },
  { name: "El Salvador", value: "El Salvador", code: "+503" },
  { name: "Equatorial Guinea", value: "Equatorial Guinea", code: "+240" },
  { name: "Eritrea", value: "Eritrea", code: "+291" },
  { name: "Estonia", value: "Estonia", code: "+372" },
  { name: "Ethiopia", value: "Ethiopia", code: "+251" },
  { name: "Falkland Islands", value: "Falkland Islands", code: "+500" },
  { name: "Faroe Islands", value: "Faroe Islands", code: "+298" },
  { name: "Fiji", value: "Fiji", code: "+679" },
  { name: "Finland", value: "Finland", code: "+358" },
  { name: "France", value: "France", code: "+33" },
  { name: "French Guiana", value: "French Guiana", code: "+594" },
  { name: "French Polynesia", value: "French Polynesia", code: "+689" },
  { name: "Gabon", value: "Gabon", code: "+241" },
  { name: "Gambia", value: "Gambia", code: "+220" },
  { name: "Georgia", value: "Georgia", code: "+995" },
  { name: "Germany", value: "Germany", code: "+49" },
  { name: "Ghana", value: "Ghana", code: "+233" },
  { name: "Gibraltar", value: "Gibraltar", code: "+350" },
  { name: "Greece", value: "Greece", code: "+30" },
  { name: "Greenland", value: "Greenland", code: "+299" },
  { name: "Grenada", value: "Grenada", code: "+1473" },
  { name: "Guadeloupe", value: "Guadeloupe", code: "+590" },
  { name: "Guam", value: "Guam", code: "+1671" },
  { name: "Guatemala", value: "Guatemala", code: "+502" },
  { name: "Guernsey", value: "Guernsey", code: "+44-1481" },
  { name: "Guinea", value: "Guinea", code: "+224" },
  { name: "Guinea-Bissau", value: "Guinea-Bissau", code: "+245" },
  { name: "Guyana", value: "Guyana", code: "+592" },
  { name: "Haiti", value: "Haiti", code: "+509" },
  { name: "Honduras", value: "Honduras", code: "+504" },
  { name: "Hong Kong", value: "Hong Kong SAR China", code: "+852" },
  { name: "Hungary", value: "Hungary", code: "+36" },
  { name: "Iceland", value: "Iceland", code: "+354" },
  { name: "India", value: "India", code: "+91" },
  { name: "Indonesia", value: "Indonesia", code: "+62" },
  { name: "Iran", value: "Iran", code: "+98" },
  { name: "Iraq", value: "Iraq", code: "+964" },
  { name: "Ireland", value: "Ireland", code: "+353" },
  { name: "Isle of Man", value: "Isle of Man", code: "+44-1624" },
  { name: "Israel", value: "Israel", code: "+972" },
  { name: "Italy", value: "Italy", code: "+39" },
  { name: "Jamaica", value: "Jamaica", code: "+1876" },
  { name: "Japan", value: "Japan", code: "+81" },
  { name: "Jersey", value: "Jersey", code: "+44-1534" },
  { name: "Johnston Island", value: "Johnston Island", code: "+1" },
  { name: "Jordan", value: "Jordan", code: "+962" },
  { name: "Kazakhstan", value: "Kazakhstan", code: "+7" },
  { name: "Kenya", value: "Kenya", code: "+254" },
  { name: "Kiribati", value: "Kiribati", code: "+686" },
  { name: "Kosovo", value: "Kosovo", code: "+383" },
  { name: "Kuwait", value: "Kuwait", code: "+965" },
  { name: "Kyrgyzstan", value: "Kyrgyzstan", code: "+996" },
  { name: "Laos", value: "Laos", code: "+856" },
  { name: "Latvia", value: "Latvia", code: "+371" },
  { name: "Lebanon", value: "Lebanon", code: "+961" },
  { name: "Lesotho", value: "Lesotho", code: "+266" },
  { name: "Liberia", value: "Liberia", code: "+231" },
  { name: "Libya", value: "Libya", code: "+218" },
  { name: "Liechtenstein", value: "Liechtenstein", code: "+423" },
  { name: "Lithuania", value: "Lithuania", code: "+370" },
  { name: "Luxembourg", value: "Luxembourg", code: "+352" },
  { name: "Macau", value: "Macau SAR China", code: "+853" },
  { name: "Macedonia", value: "Macedonia", code: "+389" },
  { name: "Madagascar", value: "Madagascar", code: "+261" },
  { name: "Malawi", value: "Malawi", code: "+265" },
  { name: "Malaysia", value: "Malaysia", code: "+60" },
  { name: "Maldives", value: "Maldives", code: "+960" },
  { name: "Mali", value: "Mali", code: "+223" },
  { name: "Malta", value: "Malta", code: "+356" },
  { name: "Marshall Islands", value: "Marshall Islands", code: "+692" },
  { name: "Martinique", value: "Martinique", code: "+596" },
  { name: "Mauritania", value: "Mauritania", code: "+222" },
  { name: "Mauritius", value: "Mauritius", code: "+230" },
  { name: "Mayotte", value: "Mayotte", code: "+262" },
  { name: "Metropolitan France", value: "Metropolitan France", code: "+33" },
  { name: "Mexico", value: "Mexico", code: "+52" },
  { name: "Micronesia", value: "Micronesia", code: "+691" },
  { name: "Moldova", value: "Moldova", code: "+373" },
  { name: "Monaco", value: "Monaco", code: "+377" },
  { name: "Mongolia", value: "Mongolia", code: "+976" },
  { name: "Montenegro", value: "Montenegro", code: "+382" },
  { name: "Montserrat", value: "Montserrat", code: "+1664" },
  { name: "Morocco", value: "Morocco", code: "+212" },
  { name: "Mozambique", value: "Mozambique", code: "+258" },
  { name: "Myanmar [Burma]", value: "Myanmar [Burma]", code: "+95" },
  { name: "Namibia", value: "Namibia", code: "+264" },
  { name: "Nauru", value: "Nauru", code: "+674" },
  { name: "Nepal", value: "Nepal", code: "+977" },
  { name: "Netherlands", value: "Netherlands", code: "+31" },
  { name: "Netherlands Antilles", value: "Netherlands Antilles", code: "+599" },
  { name: "New Caledonia", value: "New Caledonia", code: "+687" },
  { name: "New Zealand", value: "New Zealand", code: "+64" },
  { name: "Nicaragua", value: "Nicaragua", code: "+505" },
  { name: "Niger", value: "Niger", code: "+227" },
  { name: "Nigeria", value: "Nigeria", code: "+234" },
  { name: "Niue", value: "Niue", code: "+683" },
  { name: "Norfolk Island", value: "Norfolk Island", code: "+672" },
  { name: "North Korea", value: "North Korea", code: "+850" },
  {
    name: "Northern Mariana Islands",
    value: "Northern Mariana Islands",
    code: "+1670",
  },
  { name: "Norway", value: "Norway", code: "+47" },
  { name: "Oman", value: "Oman", code: "+968" },
  {
    name: "Pacific Islands Trust Territory",
    value: "Pacific Islands Trust Territory",
    code: "+692",
  },
  { name: "Pakistan", value: "Pakistan", code: "+92" },
  { name: "Palau", value: "Palau", code: "+680" },
  {
    name: "Palestinian Territories",
    value: "Palestinian Territories",
    code: "+970",
  },
  { name: "Panama", value: "Panama", code: "+507" },
  { name: "Panama Canal Zone", value: "Panama Canal Zone", code: "+507" },
  { name: "Papua New Guinea", value: "Papua New Guinea", code: "+675" },
  { name: "Paraguay", value: "Paraguay", code: "+595" },
  {
    name: "People's Democratic Republic of Yemen",
    value: "People's Democratic Republic of Yemen",
    code: "+967",
  },
  { name: "Peru", value: "Peru", code: "+51" },
  { name: "Philippines", value: "Philippines", code: "+63" },
  { name: "Pitcairn Islands", value: "Pitcairn Islands", code: "+64" },
  { name: "Poland", value: "Poland", code: "+48" },
  { name: "Portugal", value: "Portugal", code: "+351" },
  { name: "Puerto Rico", value: "Puerto Rico", code: "+1787" },
  { name: "Qatar", value: "Qatar", code: "+974" },
  { name: "Romania", value: "Romania", code: "+40" },
  { name: "Russia", value: "Russia", code: "+7" },
  { name: "Rwanda", value: "Rwanda", code: "+250" },
  { name: "Réunion", value: "Réunion", code: "+262" },
  { name: "Saint Barthélemy", value: "Saint Barthélemy", code: "+590" },
  { name: "Saint Helena", value: "Saint Helena", code: "+290" },
  {
    name: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
    code: "+1869",
  },
  { name: "Saint Lucia", value: "Saint Lucia", code: "+1758" },
  { name: "Saint Martin", value: "Saint Martin", code: "+590" },
  {
    name: "Saint Pierre and Miquelon",
    value: "Saint Pierre and Miquelon",
    code: "+508",
  },
  {
    name: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
    code: "+1784",
  },
  { name: "Samoa", value: "Samoa", code: "+685" },
  { name: "San Marino", value: "San Marino", code: "+378" },
  { name: "Saudi Arabia", value: "Saudi Arabia", code: "+966" },
  { name: "Senegal", value: "Senegal", code: "+221" },
  { name: "Serbia", value: "Serbia", code: "+381" },
  {
    name: "Serbia and Montenegro",
    value: "Serbia and Montenegro",
    code: "+381",
  },
  { name: "Seychelles", value: "Seychelles", code: "+248" },
  { name: "Sierra Leone", value: "Sierra Leone", code: "+232" },
  { name: "Singapore", value: "Singapore", code: "+65" },
  { name: "Slovakia", value: "Slovakia", code: "+421" },
  { name: "Slovenia", value: "Slovenia", code: "+386" },
  { name: "Solomon Islands", value: "Solomon Islands", code: "+677" },
  { name: "Somalia", value: "Somalia", code: "+252" },
  { name: "South Africa", value: "South Africa", code: "+27" },
  {
    name: "South Georgia and the South Sandwich Islands",
    value: "South Georgia and the South Sandwich Islands",
    code: "+500",
  },
  { name: "South Korea", value: "South Korea", code: "+82" },
  { name: "South Sudan", value: "South Sudan", code: "+211" },
  { name: "Spain", value: "Spain", code: "+34" },
  { name: "Sri Lanka", value: "Sri Lanka", code: "+94" },
  { name: "Sudan", value: "Sudan", code: "+249" },
  { name: "Suriname", value: "Suriname", code: "+597" },
  {
    name: "Svalbard and Jan Mayen",
    value: "Svalbard and Jan Mayen",
    code: "+47",
  },
  { name: "Swaziland", value: "Swaziland", code: "+268" },
  { name: "Sweden", value: "Sweden", code: "+46" },
  { name: "Switzerland", value: "Switzerland", code: "+41" },
  { name: "Syria", value: "Syria", code: "+963" },
  {
    name: "São Tomé and Príncipe",
    value: "São Tomé and Príncipe",
    code: "+239",
  },
  { name: "Taiwan", value: "Taiwan", code: "+886" },
  { name: "Tajikistan", value: "Tajikistan", code: "+992" },
  { name: "Tanzania", value: "Tanzania", code: "+255" },
  { name: "Thailand", value: "Thailand", code: "+66" },
  {
    name: "Timor-Leste(East Timor)",
    value: "Timor-Leste(East Timor)",
    code: "+670",
  },
  { name: "Togo", value: "Togo", code: "+228" },
  { name: "Tokelau", value: "Tokelau", code: "+690" },
  { name: "Tonga", value: "Tonga", code: "+676" },
  { name: "Trinidad and Tobago", value: "Trinidad and Tobago", code: "+1868" },
  { name: "Tunisia", value: "Tunisia", code: "+216" },
  { name: "Turkey", value: "Turkey", code: "+90" },
  { name: "Turkmenistan", value: "Turkmenistan", code: "+993" },
  {
    name: "Turks and Caicos Islands",
    value: "Turks and Caicos Islands",
    code: "+1649",
  },
  { name: "Tuvalu", value: "Tuvalu", code: "+688" },
  {
    name: "U.S. Minor Outlying Islands",
    value: "U.S. Minor Outlying Islands",
    code: "+1",
  },
  { name: "U.S. Virgin Islands", value: "U.S. Virgin Islands", code: "+1340" },
  { name: "Uganda", value: "Uganda", code: "+256" },
  { name: "Ukraine", value: "Ukraine", code: "+380" },
  { name: "United Arab Emirates", value: "United Arab Emirates", code: "+971" },
  { name: "United Kingdom", value: "United Kingdom", code: "+44" },
  { name: "United States", value: "United States", code: "+1" },
  { name: "Uruguay", value: "Uruguay", code: "+598" },
  { name: "Uzbekistan", value: "Uzbekistan", code: "+998" },
  { name: "Vanuatu", value: "Vanuatu", code: "+678" },
  { name: "Vatican City", value: "Vatican City", code: "+379" },
  { name: "Venezuela", value: "Venezuela", code: "+58" },
  { name: "Vietnam", value: "Vietnam", code: "+84" },
  { name: "Wake Island", value: "Wake Island", code: "+808" },
  { name: "Wallis and Futuna", value: "Wallis and Futuna", code: "+681" },
  { name: "Western Sahara", value: "Western Sahara", code: "+212" },
  { name: "Yemen", value: "Yemen", code: "+967" },
  { name: "Zambia", value: "Zambia", code: "+260" },
  { name: "Zimbabwe", value: "Zimbabwe", code: "+263" },
  { name: "Åland Islands", value: "Åland Islands", code: "+358" },
];

export default countries;
